import { render, staticRenderFns } from "./TaskRequestDetail.vue?vue&type=template&id=0cdc1259"
import script from "./TaskRequestDetail.vue?vue&type=script&lang=js"
export * from "./TaskRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskRequestDetail.vue?vue&type=style&index=0&id=0cdc1259&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports